import type { CoreApiClient } from "../client";
import { createEquipmentQueries } from "../queries/equipment.queries";

export const createEquipmentRepository = (api: CoreApiClient) => ({
  ...createEquipmentQueries(api),
});
